// import Main from './Main'
import ListaPatios from './components/ListaPatios'

export default [
  { path: '/patios/lista', component: ListaPatios, name: 'patios.lista' }
]
